export default __webpack_public_path__ + "assets/eed28b9c8557a584873adfd8aceb04dd.png";